import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { concat } from 'lodash';
import { IThemeRes } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapThemes } from './helper';

export const useGetThemes = (
  filters: string[] = [],
  overrideQuerySetting?: UseQueryOptions<IThemeRes[]>,
) =>
  useQuery({
    queryKey: queryKeys.themes.all(filters),
    queryFn: () => fetchThemes(filters),
    staleTime: Infinity,
    ...overrideQuerySetting,
  });

export const fetchThemes = async (filters: string[] = []) => {
  const url = `/themes${generateQuery([], concat(filters, 'pageSize=0'))}`;

  const response = await requestCCApi({ url });

  return mapThemes(response);
};
